import { JobsListTypes } from "src/app/job/constants/job-detail.constants";

export class InviteTradesOptions {
  static instance: InviteTradesOptions;
  primaryJobTypeId: string;
  secondaryJobTypeId: string;
  bnATrades: boolean;
  includeAllSuburbs: boolean;
  includePendingInvitationTrades: boolean;
  searchText: string;
  currentPage: number;
  totalTradesCount: number;
  jobId: string;
  suburbId: string;
  propertyId: string;
  selectedTrades: Tradee[] = [];
  jobQuoteLimit: number;
  jobBidsCount: number;
  jobListType:JobsListTypes;

  private constructor() {
    this.includeAllSuburbs = false;
    this.includePendingInvitationTrades = false;
    this.searchText = '';
    this.currentPage = 0;
    this.totalTradesCount = 0;
    this.jobId = '';
    this.bnATrades = false;
  }

  public static getInstance(): InviteTradesOptions {
    if (!InviteTradesOptions.instance)
      InviteTradesOptions.instance = new InviteTradesOptions();
    return InviteTradesOptions.instance;
  }
  public static destroyObj() {
    InviteTradesOptions.instance = undefined;
  }
}

export class Tradee {
  id: string;
  name: string;
  isInvited: boolean;
}

export interface InviteToQuoteCommand {
  jobId: string;
  targetedTradeeOption: number;
  trades: TradeDto[];
  propertyManager: string;
  quoteLimit: number;
}

export class TradeDto {
  id: string;
  isInvited: boolean;
}
